import React, { useState, useEffect, useContext } from "react";

import styles from "./styles/CredentialsMenu.module.css"
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function CredStored({ onChange, value, formErrors }) {
    const [record, setRecord] = useState({
        "record_name": value?JSON.parse(value).record_name|| "":""
    })
    const [error, setError] = useState({
        "record_name": ""
    })
    const websiteCurrentLang = useContext(LanguageContext).language;

    const [content, setContent] = useState(
        websiteCurrentLang.content.User.EditAsset.CredNotStored
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        if (formErrors['record_name'] === "error") {
            setError(prevError => ({ ...prevError, ['record_name']: dublicatedcontent?.dublicatedText212 }));
        }

        setTimeout(()=>{
            resetError()
        }, 5000)

    }, [formErrors])
    const resetError = ()=>{
        Object.keys(error).forEach(key=>{
            setError(prevError => ({ ...prevError, [key]: null }));
        })
    }
    useEffect(() => {
        onChange(record)
    }, [])
    useEffect(() => {
        if (record.record_name === "This assets has no credentials") {
            setRecord({
                "record_name": ""
            })
        }
    }, [record.record_name])
    return (
        <div className={styles.cred_field}>
            <div className={styles.input_title}>{content.credStoredText1}</div>
            <div className={styles.field_wrap}>
                <div className={`${styles.field} ${error?.record_name ? styles.field_error : ''}`}>
                <input value={record.record_name} onChange={(e) => {
                    setRecord({ ...record, "record_name": e.target.value })
                    onChange({ "record_name": e.target.value })
                }} className={styles.user_input} placeholder={dublicatedcontent.dublicatedText61}></input>
                {error?.record_name ? <div className={styles.error_message}>{error.record_name}</div> : null}
                </div>
            </div>
        </div>
    );
}

export default CredStored;
